
define('eteration/widgets/ui-common',[ 'knockout','eteration/eteration-i18n','eteration/ui/validation-helper' ], function(ko,i18n,validation) {

	ko.bindingHandlers.toggle = {
		init : function(element, valueAccessor) {
			var value = valueAccessor();
			ko.applyBindingsToNode(element, {
				click : function() {
					value(!value());
				}
			});
		}
	};

	ko.bindingHandlers.hidden = {
		update : function(element, valueAccessor) {
			var value = ko.utils.unwrapObservable(valueAccessor());
			ko.bindingHandlers.visible.update(element, function() {
				return !value;
			});
		}
	};
	
	ko.bindingHandlers.dayOverflowVisible = {
			update : function(element, valueAccessor) {
				
				var accessor = valueAccessor();
				var firstDateTime = ko.utils.unwrapObservable(accessor.firstDateTime);
				var firstDateTimeTimeZoneRawOffset = ko.utils.unwrapObservable(accessor.firstDateTimeTimeZoneRawOffset);
				var secondDateTime = ko.utils.unwrapObservable(accessor.secondDateTime);
				var secondDateTimeTimeZoneRawOffset = ko.utils.unwrapObservable(accessor.secondDateTimeTimeZoneRawOffset);
				
				var dayChangeCount = Math.floor((secondDateTime + secondDateTimeTimeZoneRawOffset)/8.64e7) - Math.floor((firstDateTime + firstDateTimeTimeZoneRawOffset)/8.64e7);

				ko.bindingHandlers.visible.update(element, function() {
					return dayChangeCount > 0;
				});
			}
	
	};

	ko.bindingHandlers.clickWithParams = {
		init : function(element, valueAccessor, allBindingsAccessor, data, context) {
			var options = valueAccessor();
			var newValueAccessor = function() {
				return function() {
					options.action.apply(data, options.params);
				};
			};
			ko.bindingHandlers.click.init(element, newValueAccessor, allBindingsAccessor, data, context);
		}
	};

	ko.bindingHandlers.fadeInText = {
		update : function(element, valueAccessor) {
			$(element).hide();
			ko.bindingHandlers.text.update(element, valueAccessor);
			$(element).fadeIn();
		}
	};

	ko.bindingHandlers.flash = {
		update : function(element, valueAccessor) {
			ko.utils.unwrapObservable(valueAccessor());
			$(element).hide().fadeIn(500);
		}
	};


    ko.bindingHandlers.fadeVisible = {
        init: function(element, valueAccessor) {
            var value = valueAccessor();
            $(element).toggle(ko.unwrap(value));
        },
        update: function(element, valueAccessor) {
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
        }
    };
    
    ko.virtualElements.allowedBindings['fadeVisible'] = true;
    
    
    

    ko.bindingHandlers.jqVisible = {
        init: function(element, valueAccessor) {
            var value = valueAccessor();
            $(element).toggle(ko.unwrap(value));
        },
        update: function(element, valueAccessor) {
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).show(10) : $(element).hide(10);
        }
    };
    
    ko.virtualElements.allowedBindings['jqVisible'] = true;
    
    
    
    
    
    
    
    
    
    ko.bindingHandlers.slideVisible = {
        init: function(element, valueAccessor) {
            var value = valueAccessor();
            $(element).toggle(ko.unwrap(value));
        },
        update: function(element, valueAccessor) {
            var value = valueAccessor();
            ko.unwrap(value) ? $(element).slideDown() : $(element).slideUp();
        }
    };
    ko.virtualElements.allowedBindings['slideVisible'] = true;
    
	
	
    ko.bindingHandlers.popover = {
    	    init: function(element, valueAccessor, allBindingsAccessor, viewModel) {
    	      var options = valueAccessor() || {};
     	      var defaultOptions = {};
     	      options.content = i18n.get(options.content);
			  options.title = i18n.get(options.title);
     	      options.html=true;
     	      options = $.extend(true, {}, defaultOptions, options);
    	    	
    	    	
    	      $(element).popover(options).on('shown.bs.popover', function(){
    	    		$('[data-dismiss="popover"]').on('click',function(){
    	    			$(element).popover('hide');
    	    		});
    	    	});
    	    }
    };
	
	
    ko.bindingHandlers.inputclean = {
			init : function(element, valueAccessor, allBindingsAccessor){
			},
			update : function(element, valueAccessor, allBindingsAccessor) {
				
				var defaultValue ="";
				var accessor = valueAccessor();
						
				$(element).focus(function() {
			        	defaultValue = accessor.value();
			        	setTimeout(function(){
			        		if(defaultValue){
			        			accessor.value("");
			        		}
			        	}, 100);
			    });
				
				$(element).blur(function(){
			        if(!accessor.value() && defaultValue){
			        	accessor.value(defaultValue);
			        	defaultValue ="";
			        }
			    });

			}

	};
    
	
	ko.bindingHandlers.validateIdentity = {
			
			init : function(element, valueAccessor, allBindingsAccessor){
			},
			update : function(element, valueAccessor, allBindingsAccessor) {
				 $(element).on("input", function (event) {
					 
					var accessor = valueAccessor();
					var identity = ko.utils.unwrapObservable(accessor.identity);
					 
					if(identity.length<11)
						return; 
					
					validation.removeError(element);
					
					var isValid = validation.tcIdValidator(identity);
					if(!isValid){
						validation.showError(element,i18n.get("Error-OB-50"));						
					}

				 });
			}
			
	};
	
	
	ko.subscribable.fn.subscribeChanged = function (callback) {
	    var savedValue = this.peek();
	    return this.subscribe(function (latestValue) {
	        var oldValue = savedValue;
	        savedValue = latestValue;
	        callback(latestValue, oldValue);
	    });
	};

    
});